const handleApiResponse = (
  enqueueSnackbar,
  response,
  successSnackbar,
  variant = null,
  action = null,
) => {
  if (successSnackbar) {
    enqueueSnackbar(response.message, {
      variant: variant || 'success',
      action,
    });
  } else {
    const errorMessage = response.response?.data?.message || response.message;
    enqueueSnackbar(errorMessage, {
      variant: variant || 'error',
      action,
    });
  }
};

export default handleApiResponse;
